module.exports = __webpack_public_path__ + "static/media/20_1.48113552.png";